var trackGAEvent = function trackGAEvent(_ref) {
  var action = _ref.action,
      category = _ref.category,
      label = _ref.label,
      value = _ref.value;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'GAEvent',
    eventAction: action,
    eventCategory: category,
    eventLabel: label,
    eventValue: value
  });
};

export default trackGAEvent;